var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('print-template',[_c('spots-print',{attrs:{"spots":_vm.spots}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }